(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('UserProfile', UserProfile);

    UserProfile.$inject = ['$resource'];

    function UserProfile($resource) {
        var resourceUrl = 'api/user-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getByUserId': {
                url: "api/user-profiles/user/:id",
                method: 'GET',
            },
            'update': {method: 'PUT'},
            'default': {
                url: "api/user-profiles/default/:authority",
                method: 'GET',
                isArray: true
            },
            'getTeamProfiles': {
                url: "api/user-profiles/team",
                method: 'GET',
                isArray: true
            },
            'alertsProfile': {
                url: "api/alert-user-profiles",
                method: 'GET',
                isArray: true
            }
        });
    }
})();
